
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { 
  FileText, 
  MessageSquare, 
  Calendar, 
  ClipboardList, 
  FileCheck, 
  FilePlus2 
} from 'lucide-react';
import ROUTES from '@/routes-map';

interface DoctorActionButtonsProps {
  doctorId?: string;
  doctorData?: {
    id: string;
    name?: string;
  };
  isDoctor?: boolean;
  className?: string;
}

const DoctorActionButtons: React.FC<DoctorActionButtonsProps> = ({ 
  doctorData,
  doctorId,
  isDoctor,
  className = ''
}) => {
  const navigate = useNavigate();
  
  // Use doctorId prop if doctorData.id is not available
  const id = doctorData?.id || doctorId || '';
  
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      <Button 
        variant="outline" 
        size="sm"
        onClick={() => navigate(`/case-file/${id}`)}
        className="flex items-center"
      >
        <FileText className="mr-2 h-4 w-4" />
        View Case File
      </Button>
      
      <Button 
        variant="outline" 
        size="sm"
        onClick={() => navigate(`/messages/${id}`)}
        className="flex items-center"
      >
        <MessageSquare className="mr-2 h-4 w-4" />
        Message
      </Button>
      
      <Button 
        variant="outline" 
        size="sm"
        onClick={() => navigate(`/patient-sessions/${id}`)}
        className="flex items-center"
      >
        <Calendar className="mr-2 h-4 w-4" />
        Sessions
      </Button>
      
      <Button 
        variant="outline" 
        size="sm"
        onClick={() => navigate(`/create-treatment-plan/${id}`)}
        className="flex items-center"
      >
        <ClipboardList className="mr-2 h-4 w-4" />
        Create Plan
      </Button>
      
      <Button 
        variant="outline" 
        size="sm"
        onClick={() => navigate(`/follow-up-reports/${id}/create`)}
        className="flex items-center"
      >
        <FileCheck className="mr-2 h-4 w-4" />
        Follow-up
      </Button>
      
      <Button 
        variant="outline" 
        size="sm"
        onClick={() => navigate(`/post-treatment/${id}`)}
        className="flex items-center"
      >
        <FilePlus2 className="mr-2 h-4 w-4" />
        Post-Treatment
      </Button>
    </div>
  );
};

export default DoctorActionButtons;
